/**
 * Possible values for the creation process type
 */ export var PlanCreationProcessType;
(function(PlanCreationProcessType) {
    /** Copy plan operation */ PlanCreationProcessType["CopyPlan"] = "CopyPlan";
    /** Published plan */ PlanCreationProcessType["PublishTarget"] = "PublishTarget";
    /** OfficeDocument plan */ PlanCreationProcessType["OfficeDocument"] = "OfficeDocument";
    /** No special creation process */ PlanCreationProcessType["None"] = "";
})(PlanCreationProcessType || (PlanCreationProcessType = {}));
